import { OpenBetColorTheme } from "./ob-color-scheme.interface";

export const COLORS_DARK: OpenBetColorTheme = {
    d: {
        primary: {
            main: "#90B5F9",
            light1: "#BBD1FB",
            light2: "#E7E9F1" /* not used */,
            light3: "#EAE9F1" /* not used */,
            deep: "#6497F6",
            contrast: "#000000DE",
            hover: "#90B5F90A", // 4%!
            selected: "#90B5F914", // 8%!
            focus: "#90B5F91F", // 12%!
            outlined_border: "#90B5F980", // 50% !
        },
        secondary: {
            main: "#495770",
            deep: "#3F495C",
            contrast: "#FFFFFF",
        },
        neutral: {
            0: "#FFFFFF",
            50: "#FAFAFA",
            100: "#F5F5F5",
            200: "#EEEEEE",
            300: "#FFFFFF29",
            400: "#BDBDBD",
            500: "#9E9E9E",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            1000: "#000000",
        },
        text: {
            primary: "#FFFFFF",
            secondary: "#FFFFFFB3", // 70%!
            disabled: "#FFFFFF61", // 38%!
            contrast: "#000000",
        },
        background: {
            main: "#11141A",
            components: "#2B2F35",
            fill: "#2B2F35",
            menu: "#36393F",
            // header: '#3E4248', /* new */
            // menu_header: '#434851', /* new */
            // menu_scroll: '#434851', /* new */
            // menu_hover: '#434851', /* new */
            filter_header: "#48505E" /* new */,
            // paper_elevation4: '#2B2F35' /* new */
            // paper_elevation8: '#36393F' /* new */
            // paper_elevation12: '#3E4248' /* new */
            // paper_elevation16: '#434851' /* new */
            // paper_elevation24: '#48505E' /* new */
        },
        button: {
            primary: "#90B5F9",
            primary_text: "#000000DE",
            secondary: "#495770",
            secondary_text: "#FFFFFF",
            tertiary: "#1E5BCE80", /// 50%!
            tertiary_text: "#1E5BCE",
        },
        divider: {
            divider: "#ffffff1f",
        },
        tag: {
            role: {
                admin: {
                    bg: "#CBBAEE",
                    text: "#000000",
                },
                operator: {
                    bg: "#96E9CD",
                    text: "#000000",
                },
                tech: {
                    bg: "#ffffff14", // 8%
                    text: "#FFFFFF",
                },
                managed_else_where: {
                    bg: "#ff5a5a",
                    text: "#FFFFFF",
                },
                custom: {
                    bg: "#EDBDAB",
                    text: "#000000",
                },
            },
            area: {
                rg: {
                    bg: "#69C8F7",
                    text: "#000000",
                },
                aml: {
                    bg: "#F3B44F",
                    text: "#000000",
                },
            },
        },
        link: {
            link: "#616161",
            colored: "#90B5F9",
        },
        alerts: {
            success: {
                background: "#0F130C",
                color: "#D8E8CC",
            },
            error: {
                background: "#160C0B",
                color: "#F4CCC7",
            },
            warning: {
                background: "#191207",
                color: "#FFE3B7",
            },
            info: {
                background: "#071218",
                color: "#B8E5FB",
            },
        },
        status: {
            success: {
                lite: "#CCF8AB",
                main: "#8FD559",
                deep: "#569F1E",
                contrast_text: "#000000DE",
                hover: "#8FD5590A", /// 4%!
                selected: "#8FD55914", /// 8%!
                focus: "#8FD5594D", /// 30%!
                outline_border: "#8FD55980", /// 50%!
            },
            error: {
                lite: "#F08678",
                main: "#E26555",
                deep: "#DB3D28",
                contrast_text: "#FFFFFF",
                hover: "#E265550A", /// 4%
                selected: "#E2655514", /// 8%
                focus: "#E265554D", /// 30%
                outline_border: "#E2655580", /// 50%
            },
            warning: {
                lite: "#F8D398",
                main: "#F3B44F",
                deep: "#E49921",
                contrast_text: "#000000DE",
                hover: "#F3B44F0A", /// 4%
                selected: "#F3B44F14", /// 8%
                focus: "#F3B44F4D", /// 30%
                outline_border: "#F3B44F80", /// 50%
            },
            info: {
                lite: "#93D3F3",
                main: "#69C8F7",
                deep: "#2A9ED8",
                contrast_text: "#000000DE",
                hover: "#69C8F70A", /// 4%
                selected: "#69C8F714", /// 8%
                focus: "#69C8F74D", /// 30%
                outline_border: "#69C8F780", /// 50%
            },
            action: {
                active: "#FFFFFF8F", /// 56%,
                hover: "#FFFFFF0A", /// 4%,
                selected: "#FFFFFF14", /// 8%,
                focus: "#FFFFFF1F", /// 12%,
                disabled: "#FFFFFF61", /// 38%,
                disabled_background: "#FFFFFF1F", /// 12%,
            },
        },
        decoration: {
            decoration2: "#5090EB" /* dont think used */,
        },

        highlights: {
            lite: "#B2DFD6",
            main: "#80CBBC",
            deep: "#4DB6A1",
            contrast_text: "#000000DE",
            hover: "#80CBBC0A", // 4%
            selected: "#80CBBC14", // 8%
            focus: "#80CBBC4D", // 30%
            outline_border: "#80CBBC80", // 50%
        },

        highlight: "#E55B77" /* not used */,
        graphical: {
            1: "#EDBDAB",
            2: "#D6C685",
            3: "#C3E990",
            4: "#99EB9E",
            5: "#96E9CD",
            6: "#A1D4DE",
            7: "#A1ABDE",
            8: "#CBBAEE",
            9: "#E6B2EB" /* new */,
            // 10: '#EDB1C6' /* new */
        },
        priorities: {
            1: {
                background: "#160C0B",
                text: "#F4CCC7",
            },
            2: {
                background: "#160C0B",
                text: "#F4CCC7",
            },
            3: {
                background: "#191207",
                text: "#FFE3B7",
            },
            4: {
                background: "#071218" /* new */,
                text: "#B8E5FB" /* new */,
            },
            5: {
                background: "#071218" /* new */,
                text: "#B8E5FB" /* new */,
            },
        },
        case_statuses: {
            open: {
                background: "#ffffff1F",
                surface1: "#FFFFFF",
            },
            in_progress: {
                background: "#071218",
                surface1: "#B8E5FB",
            },

            closed: {
                background: "#0F130C",
                surface1: "#D8E8CC",
            },
            error: {
                background: "#220907" /* not used */,
                surface1: "#F29D8A" /* not used */,
            },
        },
        risk_scores: {
            none: {
                background: "#FFFFFF1F", //12%
                color: "#FFFFFF1F",
                text: "#FFFFFF",
            },
            low: {
                background: "#FFFFFF1F", //12%
                color: "#8FD559",
                text: "#8FD559",
            },
            medium: {
                background: "#FFFFFF1F", //12%
                color: "#F3B44F",
                text: "#F3B44F",
            },
            high: {
                background: "#FFFFFF1F", //12%
                color: "#E26555",
                text: "#E26555",
            },
        },
        timelineKpis: {
            amountBet: { base: "#5090EB", gradient: "#7DAEF5" },
            amountLostWon: { base: "#E55B77", gradient: "#F28B9A" },
            amountDeposited: { base: "#92D3B2", gradient: "#B3E3C9" },
            numberOfDeposits: { base: "#97D4E8", gradient: "#B3EAF5" },
            amountWithdrawn: { base: "#F6C888", gradient: "#FFDDA8" },
            playDuration: { base: "#DF83D0", gradient: "#ECA7DF" },
            rgRiskScore: { base: "white", gradient: "#E0E0E0" },
            amlRiskScore: { base: "grey", gradient: "#B0B0B0" },
        },
        timelineEvents: {
            interaction: { base: "#92D3B2", gradient: "#B3E3C9" },
            playbreak: { base: "#E55B77", gradient: "#F28B9A" },
            limitChange: { base: "#5090EB", gradient: "#7DAEF5" },
            incident: { base: "#F6C888", gradient: "#FFDDA8" },
            message: { base: "#92D3B2", gradient: "#B3E3C9" },
            timeLimit: { base: "#C9BA33", gradient: "#E0D866" },
            moneyLimit: { base: "#C9BA33", gradient: "#E0D866" },
            limitExceeded: { base: "#C9BA33", gradient: "#E0D866" },
            login: { base: "#C9BA33", gradient: "#E0D866" },
        },
        neccton: {
            loading_indicator: {
                color: "#B8B8B8",
            },
        },
    },
};
